enum IChartTypes {
	LineSeries,
	SplineSeries,
	BarSeries,
	ScatterSeries,
	AreaSeries,
	PieSeries
}

export { IChartTypes };
